import { render, staticRenderFns } from "./ExpandChatModalV2026.vue?vue&type=template&id=64c1a805&scoped=true"
import script from "./ExpandChatModalV2026.vue?vue&type=script&lang=js"
export * from "./ExpandChatModalV2026.vue?vue&type=script&lang=js"
import style0 from "./ExpandChatModalV2026.vue?vue&type=style&index=0&id=64c1a805&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c1a805",
  null
  
)

export default component.exports